<template>
  <div class="dashboard p-8 space-y-8">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      <StatCard title="Всего пользователей" :value="totalUsers" icon="users" />
      <StatCard title="Всего партнеров" :value="totalPartners"  icon="shopping-cart" />
      <StatCard title="Total Product" value="2,450" percentage="+2.59%" icon="box" />
      <StatCard title="Total Views" value="3,456K" percentage="-0.95%" icon="eye" />
    </div>
  </div>
</template>

<script>
import StatCard from '@/components/StatCard.vue';
import { getTotalUsersWithProfiles, getTotalPartners } from '@/services/userService';

export default {
  name: "DashboardView",
  components: {
    StatCard,
  },
  data() {
    return {
      totalUsers: 0,
      totalPartners: 0,
    };
  },
  async created() {
    try {
      const usersResponse = await getTotalUsersWithProfiles();
      this.totalUsers = usersResponse.data.total_users_with_profiles;

      const partnersResponse = await getTotalPartners();
      this.totalPartners = partnersResponse.data.total_partners_with_profiles;
    } catch (error) {
      console.error('Ошибка при загрузке данных:', error);
    }
  },
};
</script>
